var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, DropdownButton, FlexBox, Image, Text, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import { createRef, PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { analytics } from 'app/utils/segment';
import { TopbarButton } from '../topbarButton';
import NoNotifications from './no-notifications.png';
import { NotificationHistoryItem } from './notificationHistoryItem';
import styles from './notificationTopbarButton.module.scss';
export class NotificationTopbarButton extends PureComponent {
    constructor(props) {
        super(props);
        this.triggerRef = createRef();
    }
    onToggleDropdown(isOpen) {
        if (isOpen) {
            analytics.topbarNotificationsOpened();
        }
    }
    notificationHistoryReset() {
        this.props.notificationHistoryReset();
    }
    close() {
        if (this.triggerRef.current) {
            this.triggerRef.current.click();
        }
    }
    render() {
        const { className, notificationsHistory } = this.props;
        let showHistoryNotificationDevider = true;
        let dropdownNotificationsFirstFive;
        let dropdownNotificationsAll;
        let showUnread = false;
        let clearNotifications;
        let restOftotalNotificationNumber = 0;
        let notifications = (_jsxs(FlexBox, Object.assign({ className: styles.empty, flexDirection: "column" }, { children: [_jsx(Image, { src: NoNotifications, alt: "no-notifications" }), _jsx("h3", { children: "Awesome" }), _jsx("h4", { children: "No notifications" })] })));
        if (notificationsHistory.length > 0) {
            showHistoryNotificationDevider = true;
            let counter = 0;
            dropdownNotificationsFirstFive = notificationsHistory
                .filter((n) => {
                if (n.showInDropdown === true && counter < 3) {
                    counter++;
                    return n;
                }
                return false;
            })
                .reverse();
            dropdownNotificationsAll = notificationsHistory.filter((n) => {
                if (n.showInDropdown === true) {
                    counter++;
                    return n;
                }
                return false;
            });
            if (dropdownNotificationsAll.length > dropdownNotificationsFirstFive.length) {
                restOftotalNotificationNumber = notificationsHistory.length - 3;
            }
            if (!dropdownNotificationsFirstFive ||
                dropdownNotificationsFirstFive.length === 0) {
                notifications = (_jsxs(FlexBox, Object.assign({ className: styles.empty, flexDirection: "column" }, { children: [_jsx(Image, { src: NoNotifications, alt: "no-notifications" }), _jsx("h3", { children: "Awesome" }), _jsx("h4", { children: "No missed notifications" })] })));
            }
            else {
                showHistoryNotificationDevider = false;
                notifications = dropdownNotificationsFirstFive.map((n) => {
                    return _jsx(NotificationHistoryItem, { notification: n }, n.id);
                });
                clearNotifications = (_jsx(FlexBox, { children: _jsx(Button, Object.assign({ variant: "tertiary", className: styles.clearNotificationsHistoryButton, onClick: this.notificationHistoryReset }, { children: "Mark all as seen" })) }));
            }
        }
        const unseenNotifications = notificationsHistory.filter((n) => n.unseen === true);
        if (unseenNotifications.length > 0) {
            showUnread = true;
        }
        const DropdownContent = (_jsxs(FlexBox, Object.assign({ className: classnames({ [styles.fullWidthContent]: this.props.alignCenter }, styles.content), flexDirection: "column", id: "topbar-notification-dropdown" }, { children: [_jsxs(FlexBox, Object.assign({ role: "headline", className: styles.headline, flexDirection: "row", flexWrap: "wrap" }, { children: [_jsx(Text.Heading, { children: "Notifications" }), clearNotifications, _jsx("span", Object.assign({ className: styles.badge }, { children: unseenNotifications.length }))] })), _jsx(FlexBox, { flexDirection: "row", role: "separator", className: styles.divider }), notifications, showHistoryNotificationDevider && (_jsx(FlexBox, { flexDirection: "row", role: "separator", className: styles.divider })), _jsx(FlexBox, Object.assign({ role: "more", className: styles.more, flexDirection: "column" }, { children: _jsxs(Link, Object.assign({ to: "/notifications", onClick: this.close, id: "" }, { children: ["See all notifications", ' ', restOftotalNotificationNumber > 0
                                ? `(${restOftotalNotificationNumber} more)`
                                : notificationsHistory.length > 0
                                    ? `(${notificationsHistory.length})`
                                    : ''] })) }))] })));
        const rootClass = classnames({
            [styles.root]: styles.root,
        }, className);
        return (_jsx(DropdownButton, Object.assign({ icon: "bell", className: rootClass, onToggle: this.onToggleDropdown, noArrow: true, noStyle: true, dropdown: DropdownContent, dropdownProps: {
                className: classnames({
                    [styles.dropdownMenuAlignCenter]: this.props.alignCenter,
                }),
            } }, { children: _jsx(TopbarButton, { showNotificationIndicator: showUnread, icon: "bell", id: "topbar-notification-button", tooltip: "Notifications" }) })));
    }
}
__decorate([
    boundMethod
], NotificationTopbarButton.prototype, "notificationHistoryReset", null);
__decorate([
    boundMethod
], NotificationTopbarButton.prototype, "close", null);
